import logo from '../../assets/logo.svg';

function Logo() {
  return <img src={logo} alt="vivamemory" />;
}

export default Logo;
